import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import { router } from './router';
import './styles/tokens.css';
import './styles/base.css';
import './styles/header.css';

// 主题系统（早期应用，避免主题闪烁）
//   - 默认主题：classic-green（homepage-design 古典绿）
//   - 备选主题：teal（原版青绿，可通过 localStorage('nrap.theme') = 'teal' 切回）
(function applyThemeEarly() {
  try {
    const t = localStorage.getItem('nrap.theme');
    const valid = ['classic-green', 'teal'];
    const theme = t && valid.includes(t) ? t : 'classic-green';
    document.documentElement.setAttribute('data-theme', theme);
  } catch {
    document.documentElement.setAttribute('data-theme', 'classic-green');
  }
})();

const app = createApp(App);
app.use(createPinia());
app.use(router);
app.mount('#app');